/**
 * Takes item from list and overwrite another field with list containing it
 * @param {String} params.from - name of the origin field
 * @param {String} params.to - field where item is copied
 * @param {String} [params.index=0] - index of item your copying
 */
export const overwriteWithCopyOfItem = function (params: any, schema: any, uiSchema: any, formData: any) {
  const { from, to, index = 0 } = params;
  if (formData[from] && formData[from].length && formData[from][index]) {
    formData[to] = [formData[from][index]]
  }
};


// Action validation
if (process.env.NODE_ENV !== 'production') {

  const PropTypes = require('prop-types');

  overwriteWithCopyOfItem.propTypes = {
    from: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
    index: PropTypes.number,
  };

  overwriteWithCopyOfItem.validate = function ({ from, to, index }: any, schema: any, uiSchema: any) {
    if (!from) {
      console.error("paramters is missing 'from' field")
    }
    if (!schema.properties[from]) {
      console.error("schema is missing property called in from parameter, note that you can only use properties in first depth of schema")
    }
    if (!to) {
      console.error("paramters is missing 'to' field")
    }
    if (index && typeof index !== 'number') {
      console.error("index parameter need to be typeof number")
    }
  };

}